// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;500;700&family=Mangal&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
@font-face {
  font-family: 'Kruti Dev 010';
  src: url('./fonts/krutidev010.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'DevLys';
  src: url('./fonts/DevLys_010.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Kokila';
  src: local('Kokila'), local('Kokila-Regular');
}

@font-face {
  font-family: 'Aparajita';
  src: local('Aparajita'), local('Aparajita-Regular');
} */

:root {
  --primary-color: #2c3e50;
  --secondary-color: #2980b9;
  --background-color: #f0f2f5;
  --card-background: #ffffff;
  --text-color: #2c3e50;
  --border-radius: 8px;
  --box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

body {
  margin: 0;
  padding: 0;
  font-family: 'Noto Sans Devanagari', 'Mangal', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  background-color: var(--background-color);
  color: var(--text-color);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Hindi input support - only apply to elements explicitly marked for Hindi */
input[lang="hi"], textarea[lang="hi"], select[lang="hi"], [contenteditable][lang="hi"] {
  font-family: 'Kruti Dev 010', monospace !important;
  font-feature-settings: "liga" 1, "calt" 1;
}

/* Kruti Dev specific styling */
textarea[style*="Kruti Dev 010"], input[style*="Kruti Dev 010"] {
  font-family: 'Kruti Dev 010', monospace !important;
  font-size: 18px;
  line-height: 1.8;
  letter-spacing: 0.5px;
}

/* Rich text editor styles */
textarea:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* Ensure Kruti Dev renders properly */
.kruti-font {
  font-family: 'Kruti Dev 010', monospace !important;
  font-variant-ligatures: normal;
  text-rendering: optimizeLegibility;
}

a {
  text-decoration: none;
  color: var(--primary-color);
}

button {
  font-family: inherit;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AACA;;;;;;;;;;;;;;;;;;;;;;;;;GAyBG;;AAEH;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,qBAAqB;EACrB,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,UAAU;EACV;;cAEY;EACZ,yCAAyC;EACzC,wBAAwB;EACxB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,6EAA6E;AAC7E;EACE,kDAAkD;EAClD,yCAAyC;AAC3C;;AAEA,+BAA+B;AAC/B;EACE,kDAAkD;EAClD,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA,sCAAsC;AACtC;EACE,kDAAkD;EAClD,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;500;700&family=Mangal&display=swap');\n/* \n@font-face {\n  font-family: 'Kruti Dev 010';\n  src: url('./fonts/krutidev010.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'DevLys';\n  src: url('./fonts/DevLys_010.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Kokila';\n  src: local('Kokila'), local('Kokila-Regular');\n}\n\n@font-face {\n  font-family: 'Aparajita';\n  src: local('Aparajita'), local('Aparajita-Regular');\n} */\n\n:root {\n  --primary-color: #2c3e50;\n  --secondary-color: #2980b9;\n  --background-color: #f0f2f5;\n  --card-background: #ffffff;\n  --text-color: #2c3e50;\n  --border-radius: 8px;\n  --box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: 'Noto Sans Devanagari', 'Mangal', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  background-color: var(--background-color);\n  color: var(--text-color);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Hindi input support - only apply to elements explicitly marked for Hindi */\ninput[lang=\"hi\"], textarea[lang=\"hi\"], select[lang=\"hi\"], [contenteditable][lang=\"hi\"] {\n  font-family: 'Kruti Dev 010', monospace !important;\n  font-feature-settings: \"liga\" 1, \"calt\" 1;\n}\n\n/* Kruti Dev specific styling */\ntextarea[style*=\"Kruti Dev 010\"], input[style*=\"Kruti Dev 010\"] {\n  font-family: 'Kruti Dev 010', monospace !important;\n  font-size: 18px;\n  line-height: 1.8;\n  letter-spacing: 0.5px;\n}\n\n/* Rich text editor styles */\ntextarea:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n/* Ensure Kruti Dev renders properly */\n.kruti-font {\n  font-family: 'Kruti Dev 010', monospace !important;\n  font-variant-ligatures: normal;\n  text-rendering: optimizeLegibility;\n}\n\na {\n  text-decoration: none;\n  color: var(--primary-color);\n}\n\nbutton {\n  font-family: inherit;\n}\n\nul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
